@if (customerCards.length > 0) {
  <div class="row mt-4">
    <fieldset class="col-12">
      <legend translate="common.debtorCardsDetails"></legend>
      <div class="col-sm-6">
        <table class="table table-borderless no-padding"
          [attr.aria-label]="'common.debtorCardsDetails' | translate">
          <thead>
            <tr>
              <th scope="col" translate="cards.table.cardNumber"></th>
              <th scope="col" translate="cards.table.uid"></th>
            </tr>
          </thead>
          <tbody>
            @for (card of customerCards; track card) {
              <tr>
                <td> {{ card.cardNumber }}</td>
                <td> {{ card.uid }}</td>
              </tr>
            }
          </tbody>
        </table>
      </div>
    </fieldset>
  </div>
}
